import { memo, useContext, useEffect, useRef } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { Step6Content } from './Step6.styled';
import { useDispatch } from 'react-redux';
import { nextStep, prevStep } from 'store/slices/global.slice';
import BaseTitle from 'components/common/BaseTitle';
import { UserFormContext } from 'components/UserForm';

const Step6 = () => {
  const dispatch = useDispatch();
  const { shortForm } = useContext(UserFormContext);
  const continueRef = useRef(null);

  useEffect(() => {
    if (continueRef.current && window.innerWidth > 768)
      continueRef.current.focus();
  }, [continueRef]);

  return (
    <AnimateTop y={window.innerWidth < 768 ? '100px' : '200px'}>
      <StepLayout title='To process your Service Request, we need some documents including, insurance details and lab orders.'>
        <Step6Content>
          <BaseTitle type='subtitle' fw={500}>
            INSTRUCTIONS: If you have a file attachment with multiple pages,
            great!. Otherwise, you can take a picture or scan one page and
            upload it as prompted on each of the questions below or, if you are
            not ready to submit document now,just skip this step,but keep in
            mind that we need some documents that can be provided at a later
            time.
          </BaseTitle>
        </Step6Content>
        <Footer
          nextArrowClick={() => dispatch(nextStep({ step: 61 }))}
          prevArrowClick={() => dispatch(prevStep())}
        >
          <FooterOkBtn
            onClick={() => dispatch(nextStep({ step: 61 }))}
            ref={continueRef}
          >
            Continue
          </FooterOkBtn>
          <FooterOkBtn
            onClick={() => dispatch(nextStep({ step: !shortForm ? 7 : 5 }))}
          >
            Skip file upload
          </FooterOkBtn>
          <FooterPressText>press Enter ↵</FooterPressText>
        </Footer>
      </StepLayout>
    </AnimateTop>
  );
};

export default memo(Step6);
